import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class RoleGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // this will be passed from the route config
    // on the data property
    const expectedRole = route.data.expectedRole;

    const token = this.auth.getTokenDecode();

    if (token == null){
      this.router.navigate(['login']);
      return false;
    }

    // decode the token to get its payload
    const tokenPayload = token.role;

    if (tokenPayload === undefined) {
      return false;
    }

    const permisosToken = JSON.parse(this.auth.getTokenDecode().role);

    const permiso = permisosToken.find(x => x === expectedRole);

    if (!this.auth.isAuthenticated() || !permiso) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }

  canVisible(route: string): boolean {
    // this will be passed from the route config
    // on the data property

    const permisosToken: string[] = JSON.parse(this.auth.getTokenDecode().role);
    const permiso = permisosToken.find(x => x === route);

    if (permiso !== route) {
      return false;
    }
    return true;
  }
}
